// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.event-description-modal {\n\tpadding: 20px;\n}\n.v--modal-overlay {\n\tz-index: 9999;\n}\n.v--modal {\n\tmax-height: 90%;\n\toverflow-y: auto;\n}\n", ""]);
// Exports
module.exports = exports;
